import styled from "@emotion/styled";
import { useState, type ReactNode } from "react";
import { useNavigate } from "react-router";

import { useUserAttributes } from "@skilitics/designer-auth/attributes";
import { ContextMenuIconButton, Divider, transientOptions } from "@skilitics/designer-ui-components";

import { UserAccountMenu } from "./UserAccountMenu";
import { UserAvatar } from "./UserAvatar";
import { WorkspaceMenuItems } from "./WorkspaceMenu";

const UserDropdownMenu = styled.div`
  ${ContextMenuIconButton} {
    width: auto;
    height: auto;
    padding: 0;
    border-radius: 50px;
  }
`;

const StyledAvatar = styled(UserAvatar, transientOptions)`
  width: 34px;
  height: 34px;
  border: solid 1px ${({ theme }) => theme.outlineSoft};
  background: ${({ theme }) => theme.primaryContainer};
`;

export const HeaderSuffix = () => {
  const user = useUserAttributes();

  const navigate = useNavigate();

  const [newOrgDialog, setNewOrgDialog] = useState<ReactNode>(null);

  const closeOpenModule = async () => {
    await navigate("/");
  };

  if (!user) {
    return null;
  }

  return (
    <UserDropdownMenu>
      <UserAccountMenu
        data-test="header-settings-button"
        trigger={<StyledAvatar email={user.email} />}
        additionalItems={
          <>
            <Divider />
            <WorkspaceMenuItems
              setNewOrgDialog={setNewOrgDialog}
              onWorkspaceSelected={closeOpenModule}
              showWorkspaceHeader
            />
          </>
        }
      />
      {newOrgDialog}
    </UserDropdownMenu>
  );
};
